import RandomCharacterList from './RandomCharacterList';
import "./Home.css";


function ExplorePage() {
  return (
    <div className="Explore">
      <h1>Explore Page</h1>
     <RandomCharacterList />
    </div>
  );
}

export default ExplorePage;